define('components/util/locale',[
    'jquery'
],function(
    jQuery
){
    var NUMERIC_DEFAULT_DECIMAL = ".";
    var lang = companyInfo.lang;

    var locale = [];
      locale.nl = {
        decimal: ","
      };
      locale.en = {
        decimal: "."
      };
      locale.de = {
          decimal: ","
      };

    var zeroPadding = function (num, dec) {
      var s = num+"";
      var v;
      var arr = s.split(dec);
      if(arr[0].length > 0){
        v = arr[0];
      }else{
        v = 0;
      }

      if(arr.length>1){
        if(arr[1].length > 0){
          v += dec+arr[1];
        }
      }

      return v;
    };

    return {
        /**
         * set the right decimals for sending data to the server. NUMERIC_DEFAULT_DECIMAL
         * @param {[type]} val [description]
         */
        setNumeric2Server: function(val){
          if(!val){return '';}
          val = val.replace(",", NUMERIC_DEFAULT_DECIMAL);
          val = zeroPadding(val, NUMERIC_DEFAULT_DECIMAL);
          return val;
        },
        getLocale: function(){
          return lang;
        },
        getNumeric: function(val){
          if(!val){return '';}
          val = val.replace(NUMERIC_DEFAULT_DECIMAL, locale[lang].decimal);
          val = zeroPadding(val, NUMERIC_DEFAULT_DECIMAL);

          return val;
        }

    };

});

